<template>
  <div class="cityPlatformOrderPage">
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="margin-left: 20px"></i>
      <a-button type="primary" @click="add">新增</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click.stop="edit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm
          placement="right"
          okText="确认"
          cancelText="取消"
          @confirm="deleteClick(record)"
        >
          <template slot="title">是否确认删除{{ record.name }}</template>
          <a href="javascript:;" style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal
      :title="title"
      v-model="addKeyVisible"
      :maskClosable="false"
      :afterClose="addClose"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="城市:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="cityIdList"
            :options="options"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
        </a-form-item>
        <a-form-item
          label="平台:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="platformIdList"
            placeholder="请选择平台"
            class="select-tag"
            allowClear
            style="width: 190px"
            mode="multiple"
          >
            <a-select-option
              v-for="(item, index) in platformSelectList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
          <i style="margin-left: 20px"></i>
          <a-button type="primary" @click="addPlatform">添加平台</a-button>
        </a-form-item>
        <a-form-item
          label="平台排序:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <draggable v-model="platformOrderList">
            <div
              v-for="(item, index) in platformOrderList"
              class="platformList"
            >
              <div class="platform">
                {{ item.name }}
                <span style="float: right" @click="deletePlatform">
                  <a-icon type="delete"></a-icon>
                </span>
              </div>
            </div>
          </draggable>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="add_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/cityPlatformOrderPage.js";
import platformListApi from "../lib/platformList.js";
import draggable from "vuedraggable";

export default {
  name: "cityPlatformOrderPage",
  components: { draggable },
  data() {
    return {
      title: "",
      addKeyVisible: false,
      loading: false,
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "城市",
          dataIndex: "cityIdListLabel",
        },
        {
          title: "平台",
          dataIndex: "platformIdListLabel",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      platformSelectList: [],
      platformOrderList: [],
      platformIdList: [],
      paramList: [],
      options: [],
      allParamList: [],
      cityIdAdd: [],
      props: {
        multiple: true,
        children: "childrenList",
        value: "id",
        label: "content",
        emitPath: false,
      },
      cityIdList: [],
      id: "",
    };
  },
  mounted() {
    this.getAreaList();
  },
  methods: {
    deletePlatform(index) {
      this.platformOrderList.splice(index, 1);
    },
    addPlatform() {
      if (this.platformIdList.length > 0) {
        let flag = true;
        this.platformIdList.forEach((platformId) => {
          this.platformOrderList.forEach((platform) => {
            if (platform.id == platformId) {
              flag = false;
            }
          });
        });
        if (flag) {
          this.platformIdList.forEach((platformId) => {
            this.platformSelectList.forEach((platform) => {
              if (platform.id == platformId) {
                this.platformOrderList.push(platform);
              }
            });
          });
        } else {
          this.$message.warning("请勿重复添加相同的平台");
        }
        this.platformIdList.splice(0);
      } else {
        this.$message.warning("请先选择要添加的平台");
      }

      if (!this.addKeyVisible) {
        this.addKeyVisible = true;
      }
    },
    getAreaList() {
      platformListApi.areaList().then((res) => {
        if (res.result == 200) {
          this.options = res.data;
          this.getPlatformList();
        }
      });
    },
    getPlatformList() {
      platformListApi.queryPage({ enabled: true }).then((res) => {
        if (res.result == 200) {
          this.platformSelectList.splice(0);
          this.platformSelectList.push(...res.data);
          this.query(1);
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        pageSize: 10,
        pageNo: this.pageNo,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data.records;
            this.tableDataSource.forEach((item) => {
              let cityIdListLabel = [];
              let platformIdListLabel = [];
              this.options.forEach((province) => {
                province.childrenList.forEach((city) => {
                  item.cityIdList.forEach((cityId) => {
                    if (city.id == cityId) {
                      cityIdListLabel.push(city.content);
                    }
                  });
                });
              });
              this.platformSelectList.forEach((platform) => {
                item.platformIdList.forEach((platformId) => {
                  if (platform.id == platformId) {
                    platformIdListLabel.push(platform.name);
                  }
                });
              });
              this.$set(item, "cityIdListLabel", cityIdListLabel.join(","));
              this.$set(
                item,
                "platformIdListLabel",
                platformIdListLabel.join(",")
              );
            });
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    changePageItem(index) {
      this.query(index);
    },
    // 新增
    add() {
      this.title = "新增";
      this.cityIdList = [];
      this.platformIdList = [];
      this.platformOrderList = [];
      this.addKeyVisible = true;
    },
    edit(val) {
      this.title = "修改";
      this.id = val.id;
      this.cityIdList = val.cityIdList;
      this.platformIdList = val.platformIdList;
      this.platformOrderList.splice(0);
      this.addPlatform();
    },
    addClose() {
      this.getPlatformList();
    },
    // 确定新增
    add_submit() {
      let platformIdList = [];
      this.platformOrderList.forEach((item) => {
        platformIdList.push(item.id);
      });
      let data = {
        cityIdList: this.cityIdList,
        platformIdList,
      };
      if (this.title == "新增") {
        api.addData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("添加成功");
            this.query();
          }
        });
      } else {
        data.id = this.id;
        api.editData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("修改成功");
            this.query();
          }
        });
      }
    },
    // 点击删除
    deleteClick(val) {
      let data = {
        id: val.id,
      };
      api.deleteData(data).then((res) => {
        if (res.result === 200) {
          this.$message.success("删除成功");
          this.query();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-cascader {
  margin-bottom: 0px !important;
  &:deep() .el-cascader__search-input {
    min-width: 2px;
  }
}
.action-class :deep() .ql-formats {
  margin-right: 0 !important;
  line-height: 24px !important;
}
.action-class :deep() .ql-container {
  height: 350px !important;
}
.platformList {
  .platform {
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    padding: 5px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    margin-bottom: 5px;
  }
}
.cityPlatformOrderPage {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
      height: 32px;
      line-height: 32px;
    }
    .backup {
      padding: 5px 0;
    }
    input {
      width: 240px;
    }
    span {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
